import { registerArchetype } from './index.js';
import { livingAllies, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'buff',
    apply: ({ state, source, params }) => {
        const stat = params.stat ?? 'atk';
        const amountPct = params.amountPct ?? 0.1;
        const duration = params.duration ?? 5;
        const target = params.target ?? 'all_allies';
        const targets = target === 'self'
            ? [{ slot: source.slot }]
            : livingAllies(state, source.side).map(a => ({ slot: a.slot }));
        for (const t of targets) {
            getRuntimes(state, source.side)[t.slot].statuses.push({
                id: `buff_${stat}_${state.tick}_${t.slot}`,
                kind: 'buff',
                remainingTicks: duration,
                params: { [stat]: amountPct }
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: source.side, slot: t.slot, status: 'buff', duration });
        }
    }
});
